import React from 'react';
import ClinicMasterProductsTableContainer from './containers/ClinicMasterProductsTableContainer';
import { Body, Container, Header } from '../Shared/Table';
import { HealtheraButton } from '../../healtheraComponents';
import { Typography } from '@material-ui/core';
import { useHistory, useParams } from 'react-router';
import useClinicById from '../Clinics/ModifyClinic/hooks/useClinicById';
import GlobalDefaultClinicBanner from '../Clinics/ModifyClinic/components/GlobalDefaultClinicBanner';

interface RouteParams {
  clinicId: string;
}

const ClinicMasterProductTable = () => {
  const { clinicId } = useParams<RouteParams>();
  const history = useHistory();
  const { clinic } = useClinicById(clinicId);

  const handleAddNew = () => {
    history.push(`/clinics/${clinicId}/products/create`);
  };

  const isGlobalDefaultClinic = clinic?.selection_visibility === 'global_default';

  return (
    <Container>
      <Header>
        <Typography variant="h4">Clinic Products</Typography>
        <HealtheraButton onClick={handleAddNew}>Add new</HealtheraButton>
      </Header>
      
      {isGlobalDefaultClinic && clinic && (
        <GlobalDefaultClinicBanner />
      )}
      
      <Body>
        <ClinicMasterProductsTableContainer clinicId={clinicId} />
      </Body>
    </Container>
  );
};

export default ClinicMasterProductTable;
